import React from 'react';
import ButtonGeneral from './ButtonGeneral';

type Props = {
    callbackSave: () => void;
    title?: string;
    loading?: boolean;
    locked?: boolean;
    message?: string;
};

const ButtonSaveForm = ({
    callbackSave,
    title = 'Guardar',
    loading = false,
    locked = false,
    message = 'No se puede guardar este registro.'
}: Props) => {
    return (
        <ButtonGeneral
            onClick={callbackSave}
            title={title}
            loading={loading}
            locked={locked}
            errorMessage={message}
            variant="primary"
            size="small"
            icon="fa-save"
        />
    );
};

export default ButtonSaveForm;
